export default __webpack_public_path__ + "static/media/Trivia.bfbdbbe1.png";